import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import ReactDataGrid from 'react-data-grid';
import 'bootstrap/dist/css/bootstrap.css';

class WalletsBoard extends Component {

	constructor(props,context) {
	    super(props,context);
	    this._columns = [
	      {
	        key: 'name',
	        name: 'Name',
	        width: 420,
	        resizable: true,
	        sortable: true
	      },
	      {
	        key: 'email',
	        name: 'Email',
	        width: 420,
	        resizable: true,
	        sortable: true
	      },
	      {
	        key: 'wallet',
	        name: 'Current amount',
	        width: 160,
	        resizable: true,
	        sortable: true,
	        formatter: this.formatAmount
	      }
	    ];
	    let originalRows = this.props.items;
	    let rows = originalRows.slice(0);
	    this.state = { originalRows, rows };
	    this.rowGetter = this.rowGetter.bind(this);
	    this.handleGridSort = this.handleGridSort.bind(this);
	    this.makeIdClickable = this.makeIdClickable.bind(this);
	    this.formatAmount = this.formatAmount.bind(this);
	}

	formatAmount(value){
		if(value.value === null){
			return "0€";
		}else{
			return value.value + "€";
		}
	}

	makeIdClickable(value){
		return <Link to={'/projects/'+value.value} key={value.value}>{value.value}</Link>
	}

	handleGridSort(sortColumn, sortDirection){
	    const comparer = (a, b) => {
	      if (sortDirection === 'ASC') {
	        return (a[sortColumn] > b[sortColumn]) ? 1 : -1;
	      } else if (sortDirection === 'DESC') {
	        return (a[sortColumn] < b[sortColumn]) ? 1 : -1;
	      }
	    };

	    const rows = sortDirection === 'NONE' ? this.state.originalRows.slice(0) : this.state.rows.sort(comparer);

	    this.setState({ rows });
	}

	rowGetter(i){
	    return this.state.rows[i];
	}

	render() {
		return (
			<div className="adminBoard">
				<ReactDataGrid
			        onGridSort={this.handleGridSort}
			        columns={this._columns}
			        rowGetter={this.rowGetter}
			        rowsCount={this.state.rows.length}
			        minHeight={400} />
			</div>
		);
	}
}

export default WalletsBoard;



// WEBPACK FOOTER //
// ./src/components/Admin/WalletsBoard.js